<template>
  <v-flex xs12 sm12 md12 lg12 xl12>
    <head>
      <link href="https://vjs.zencdn.net/7.5.4/video-js.css" rel="stylesheet">
    </head>       
  
    <v-card-title 
      class="headline white lighten-2"
      primary-title
      style="color:grey;font-family:Poppins!important;font-size:1.8vw;font-weight:400; margin-left:10px"> 
        {{capacitacion_data.title}}     
    </v-card-title>    

    <div align="center">         
      <video-player ref="player" :options="videoOptions"/>
      
    </div>
        
    <v-dialog v-model="dialogAvance" width="850">
      <avance-video ref="avance"></avance-video>
    </v-dialog>
  </v-flex>
</template>

<script>
import VideoPlayer from "@/components/VideoPlayerLecciones.vue"
import qs from 'querystring'
import axios from 'axios'
import AvanceVideo from "../components/AvanceVideo.vue"

let capacitacion_data;

export default {
  props:['capacitacion'],
  components:{
    VideoPlayer,AvanceVideo
  },
  data(){
    
     capacitacion_data = Object.assign({}, capacitacion_data, this.capacitacion);
      return{
        dialogAvance:false,
        state:false,
        isLesson:false,
        capacitacion_data,        
        dialog:false,
        videoOptions:{
          autoplay:false,
          controls:true,
          preload:'auto',
          width:800,
          sources:[
            {
              src:capacitacion_data.url,
              type: "video/mp4"                
            }
          ]
        },
        videoOptions:{
          autoplay:false,
          controls:true,
          preload:'auto',
          width:300,
          sources:[
            {
              src:capacitacion_data.url,
              type: "video/mp4"                
            }
          ]
        },
      }
  },
  
  methods:{
    setContent: function (cap){
      
      this.capacitacion_data=cap;
      var o ={
          autoplay:false,
          controls:true,
          preload:'auto',
          width:800,
          sources:[
            {
              src:cap.url,
              type: "video/mp4"                
            }
          ]
        }

      this.$refs.player.setVideoOptions(o)
      this.$refs.player.videoReload(o.sources[0].src)
      
      
       /*this.$refs.player.setOnVideoEnd(        
          this.$refs.avance.openAvance
          
      );*/
      this.$refs.player.setOnVideoEnd(()=>{  
               
      var progress = Math.floor(this.$refs.player.getCurrentTime());
      var formdata = new FormData();
      formdata.set('video', this.capacitacion_data.url);
      formdata.set('progress', progress)
      var data= qs.stringify({"video":this.capacitacion_data.url,"progress":progress,"completed":true})        
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer '.concat(token);
      axios.defaults.headers.common['Authorization'] = "Bearer "+token
      axios(
      {
        url: 'https://lalabumapp.com:4443/SetUserProgress', 
        method:"POST",
        data:data
      }).then(resp => 
        {
          
          this.capacitaciones=resp.data.data

          axios.get("https://lalabumapp.com:4443/GetUserProgress",{ headers: { Authorization: AuthStr } })
        .then(resp => {
        
        this.$refs.avance.porcentaje=resp.data.data.completion
        //alert(this.$refs.avance.porcentaje)
        this.$refs.avance.dialog1=true
        
        })
        .catch(() => {
        
      })
        }).catch(() => {
            
        })
    
    })

    this.$refs.player.setIntervalAction(()=>{            
      var progress = Math.floor(this.$refs.player.getCurrentTime());
      var formdata = new FormData();
      formdata.set('video', this.capacitacion_data.url);
      formdata.set('progress', progress)
      var data= qs.stringify({"video":this.capacitacion_data.url,"progress":progress})        
      const token = localStorage.getItem('token')
      axios.defaults.headers.common['Authorization'] = "Bearer "+token
      axios(
      {
        url: 'https://lalabumapp.com:4443/SetUserProgress', 
        method:"POST",
        data:data
      }).then(resp => 
        {
          
          this.capacitaciones=resp.data.data
        }).catch(() => {

        })
        
    })

      
    },
    Close(){
            this.$refs.player.playerClose();
        },
    },

  /*watch: {
    dialog(val){
      !val&&this.$refs.player.playerClose();
    }
  }*/
}


</script>

<style>
.playvideo:hover{
  transform: scale(1.2);
}
</style>
